import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
  Layout,
  TextField,
  Button,
  Text,
  Col
} from 'athenaeum';

import { trackClickedCTA } from 'utils/analytics/track';
import styles from './capture_cta.module.scss';

class CaptureCta extends React.Component {
  constructor() {
    super();

    if (!this) {
      return null;
    }

    this.state = {
      value: ''
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    if (!this) {
      return null;
    }

    return this.setState({ value: event.target.value });
  }

  render() {
    if (!this) {
      return null;
    }

    const {
      className,
      buttonText,
      placeholder,
      method,
      inputName,
      actionPath,
      layoutProps,
      inputType,
      inputClassName,
      id,
      stickyNavButtonId,
    } = this.props;

    const classes = cx(
      styles['capture-cta'],
      className,
    );

    const inputClasses = cx(
      styles.text,
      'AB-test-text',
      inputClassName
    );

    // TODO: Remove AB testing stuff asap
    return (
      <form data-type="single-form" className={classes} action={actionPath} method={method}>
        <Layout
          {...layoutProps}
          nested
          id="AB-test-cta"
          className={cx(styles.capture, layoutProps.className)}
        >
          <TextField
            placeholder={placeholder}
            input={{
              name: inputName,
              value: this.state.value,
              onChange: this.onChange,
              type: inputType,
            }}
            className={inputClasses}
          />
          <Col>
            <Button
              type="submit"
              onClick={() => { trackClickedCTA(id); }}
              id={stickyNavButtonId}
            >
              { buttonText }
            </Button>
          </Col>
          <Col className="AB-test-zipcode">
            <Text bold>
              Zip code
            </Text>
          </Col>
        </Layout>
      </form>
    );
  }
}

CaptureCta.propTypes = {
  /**
   * This prop will add a new className to any inherent classNames
   * provided in the component's index.js file.
   */
  className: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  method: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  inputType: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  actionPath: PropTypes.string.isRequired,
  inputClassName: PropTypes.string,
  layoutProps: PropTypes.object,
  id: PropTypes.string.isRequired,
  stickyNavButtonId: PropTypes.string,
};

CaptureCta.defaultProps = {
  layoutProps: {
    smallCols: [12],
    mediumCols: [5, 3],
    largeCols: [3, 2],
    className: '',
  },
  inputType: 'text',
  method: 'post'
};

export default CaptureCta;



// WEBPACK FOOTER //
// ../src/components/CTA/CaptureCTA/index.js